// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5797":"8df75fd9","9547":"8e098e1c"}[chunkId] + ".chunk.css";
};